import React from 'react'
import PropTypes from 'prop-types'
import './BoardingLayout.css'
import { withStyles } from '@material-ui/core/styles'
export const BoardingLayout = ({ children, theme }) => (
  <div
    style={{ backgroundColor: theme.palette.primary.light }}
    className="boardingPage">
    {children}
  </div>
)
BoardingLayout.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node
}

export default withStyles({}, { withTheme: true })(BoardingLayout)



// WEBPACK FOOTER //
// ./src/layouts/BoardingLayout/BoardingLayout.js